/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Infantry:       'infantry',
  Rangers:        'rangers',
  Outpost:        'outpost',
  Artillery:      'artillery',
  AssaultTroops:  'assault-troops',
  SpecialForces:  'special-forces',
  RocketLauncher: 'rocket-launcher',
  ShieldDome:     'shield-dome',
  Gate:           'gate',
  MechInfantry:   'mechanized-infantry',
};
